import request from "./request";

const UserService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/user/all`, context.token, signal);
    },
    GetAllWithFilter: async (searchtext, context) => {
        if (searchtext == null || searchtext === '') {
            return await this.GetAll(context);
        } else {
            return await request.sendRequest(`/user/all/${searchtext}`, context.token);
        }
    },
    GetImpersonateAll: async (searchText, context) => {
        return await request.sendRequest(`/user/impersonate/all/${searchText}`, context.token);
    },
    GetAllExceptLearners: async (context) => {
        return await request.sendRequest(`/user/except/all`, context.token);
    },
    GetAllLearners: async (context, signal) => {
        return await request.sendRequest(`/user/learners/all`, context.token, signal);
    },
    GetAllTags: async (context, signal) => {
        return await request.sendRequest(`/user/all/tags`, context.token, signal);
    },
    Get: async (userId, context, signal) => {
        return await request.sendRequest(`/user/details/${userId}`, context.token, signal);
    },
    GetProfile: async (context, signal) => {
        return await request.sendRequest(`/user/profile`, context.token, signal);
    },
    GetList: async (context, signal) => {
        return await request.sendRequest(`/user/list/1`, context.token, signal);
    },
   ForgotPassword: async (emailId, signal) => {
   let email = encodeURIComponent(emailId);
   return await request.sendRequest(`/user/sendresetlink/${email}`, signal);
    },
    ResetPassword: async (model) => {
        return await request.sendUnAuthPostRequest(`/user/resetpassword`, model);
    },
    Reset: async (id, context) => {
        return await request.sendRequest(`/user/reset/${id}`, context.token);
    },
    ApproveUser: async (model) => {
        return await request.sendUnAuthPostRequest(`/user/approve`, model);
    },
    RejectUser: async (model) => {
        return await request.sendUnAuthPostRequest(`/user/reject`, model);
    },
    ValidateReCaptcha: async (response, signal) => {
        return await request.sendUnAuthPostRequest(`/user/validatecaptcha/`, response, signal);
    },
    GetQrCode: async (context, signal) => {
        return await request.sendRequest(`/user/qrcode`, context.token, signal);
    },
    ReConfigureQrCode: async (code, context, signal) => {
        return await request.sendRequest(`/user/reconfigureqrcode/${code}`, context.token, signal);
    },
    ValidateQrCode: async (response, context, signal) => {
        return await request.sendPostRequest(`/user/validateqrcode`, response, context, signal);
    },
    VerifyQrCode: async (response, context, signal) => {
        return await request.sendPostRequest(`/user/verifyqrcode`, response, context, signal);
    },
    SendOTP: async (context, signal) => {
        return await request.sendRequest(`/user/sendotp`, context.token, signal);
    },
    SendMFAOTP: async (context, signal) => {
        return await request.sendRequest(`/user/mfaotp`, context.token, signal);
    },
    ValidateOTP: async (otp, context, signal) => {
        return await request.sendPostRequest(`/user/validateotp`, otp, context, signal);
    },
    GetMFAQ: async (context, signal) => {
        return await request.sendRequest(`/user/mfaq`, context.token, signal);
    },
    ImpersonateUser: async (id, context) => {
        return await request.sendRequest(`/token/impersonate/${id}`, context.token);
    },
    RollbackUser: async (id, context) => {
        return await request.sendRequest(`/token/impersonate/rollback/${id}`, context.token);
    },
   ValidateMFAOTP: async (otp, context, signal) => {
        return await request.sendPostRequest(`/user/validatemfaotp`, otp, context, signal);
    },
    ValidateSQ: async (sqa, context, signal) => {
        return await request.sendPostRequest(`/user/validatesq`, sqa, context, signal);
    },
    UpdateProfile: async (sqa, context) => {
        return await request.sendPutRequestWithBody(`/user/update/profile`, sqa, context);
    },
    Save: async (payload, context) => {
        return await request.sendPostRequest(`/user`, payload, context);
    },
    SaveLearner: async (payload, context) => {
        return await request.sendPostRequest(`/user/learner`, payload, context);
    },
    ResetMFA: async (id, context) => {
        return await request.sendPutRequest(`/user/resetmfa/${id}`, context);
    },
    Import: async (payload, context) => {
        return await request.sendFormDataRequest(`/user/import`, payload, context);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/user/${id}`, context.token);
    },
    RemoveByTag: async (tag, context) => {
        return await request.sendDeleteRequest(`/user/tag/${tag}`, context.token);
    },
    GetLoginHistory: async (context, signal) => {
        return await request.sendRequest(`/user/loginhistory`, context.token, signal );
    },
    GetLoginHistoryByUserId: async (userId, context, signal) => {
        return await request.sendRequest(`/user/${userId}/loginhistory`, context.token, signal);
    },  
    GetFirstLoginPolicy: async (skip, take, fromDate = "", toDate = "", acceptanceStatus = "", searchText = "", context, signal) => {
        return await request.sendRequest( `/user/policy/${skip}/${take}/${fromDate}/${toDate}/${acceptanceStatus}/${searchText}`, context.token, signal);
    },

};

export default UserService;
